<template>
  <div class="d-content__section">
    <section class="main-content-section">
      <div class="top-bar">
        <span @click="goBackToSalaryRegisterPage">
          <i class="left"></i>
        </span>
        <span class="heading_new">Download Register</span>
        <span class="spacer" />
      </div>
      <div class="d-payroll__accord marginbottom-10p margintop-30">
        <div class="d-payroll__accordBlock active">
          <div class="accordHeading d-heading">Company Info</div>
          <div class="accordContent">
            <div class="row">
              <div class="col-4">
                <div class="row">
                  <div class="col-12">
                    <tl-checkbox label="Cost Center" name="cost_center" id="cost_center" @change="(val) => isCostCenterChecked = val"/>
                    <tl-select label :options="costCenterList" :disable="!isCostCenterChecked" class="marginleft-10p" />
                  </div>
                  <div class="col-12">
                    <tl-checkbox label="Salary bands" name="salary_bands" id="salary_bands" @change="(val) => isSalaryBandsChecked = val" />
                    <tl-select label :options="salaryBands" :disable="!isSalaryBandsChecked" class="marginleft-10p" />
                  </div>
                  <div class="col-12 ">
                    <tl-checkbox
                      label="Employer contribution"
                      name="employer_contri"
                      id="employer_contri"
                      @change="employerContribution($event)"
                    />
                    <div class="twoColumnGrid p-10 marginbot-20 marginleft-5p">
                      <tl-radio
                        label="Gross column"
                        name="employer_contri"
                        value="grossColumn"
                        id="contri_gross"
                        :disabled="!employerContri"
                        v-model="employerContri"
                      />
                      <tl-radio
                        label="Net Pay column"
                        name="employer_contri"
                        value="netPayColumn"
                        id="contri_netPay"
                        :disabled="!employerContri"
                        v-model="employerContri"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <tl-checkbox label="Unpaid CTC components" name="unpaid_ctc" id="unpaid_ctc" @change="unpaidCTCComponents($event)"/>
                    <div class="twoColumnGrid p-10 marginbot-20 marginleft-5p">
                      <tl-radio
                        label="Gross column"
                        name="unpaid_ctc"
                        value="grossColumn"
                        id="unpaid_gross"
                        :disabled="!unpaidCTC"
                        v-model="unpaidCTC"
                      />
                      <tl-radio
                        label="Net Pay column"
                        name="unpaid_ctc"
                        value="netPayColumn"
                        id="unpaid_netPay"
                        :disabled="!unpaidCTC"
                        v-model="unpaidCTC"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4 marginleft-5p">
                <div class="row margintop-30">
                  <div class="col-12 marginbot-20">
                    <tl-checkbox label="FBP Components" name="fbp_components" id="fbp_components" />
                  </div>
                  <div class="col-12 marginbot-20">
                    <tl-checkbox
                      label="Standard CTC components"
                      name="ctc_components"
                      id="ctc_components"
                    />
                  </div>
                  <div class="col-12 marginbot-20">
                    <tl-checkbox label="LOP amount difference" name="lop_amount" id="lop_amount" />
                  </div>
                  <div class="col-12 marginbot-20">
                    <tl-checkbox label="EPS and EDLI" name="eps_edli" id="eps_edli" />
                  </div>
                  <div class="col-12 marginbot-20">
                    <tl-checkbox
                      label="Group by departments"
                      name="groupbydepartments"
                      id="groupbydepartments"
                    />
                  </div>
                  <div class="col-12">
                    <tl-checkbox
                      label="Allow columns with zero values"
                      name="zero_values"
                      id="zero_values"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-payroll__accordBlock active">
          <div class="accordHeading d-heading">Employee Info</div>
          <div class="accordContent">
            <div class="threeColumnGrid">
              <div v-for="(item, index) in employeeInfoList" :key="index">
                <tl-checkbox
                  :label="item.label"
                  :name="'employeeInfo'+index"
                  :id="'employeeInfo'+index"
                  :checked="item.checked"
                  v-model="item.checked"
                  @change="employeeInfoChecked($event,item)"
                />
                <div class="twoColumnGrid p-10 marginleft-5p" v-if="item.label == 'Employee status'">
                  <tl-radio label="Active" name="employeeStatus" value="active" id="active" :disabled="!item.employeeStatus" v-model="item.employeeStatus"/>
                  <tl-radio label="Inactive" name="employeeStatus" value="inactive" id="inactive" :disabled="!item.employeeStatus" v-model="item.employeeStatus"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal custom-modal" v-if="showModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Export As</h3>
        </div>
        <div class="modal-body">
          <div class="singleColumnGrid p-10">
            <tl-radio label="Single File" name="reports" id="single_file" value="singleFile" />
            <tl-radio
              label="Multiple Files"
              name="reports"
              id="multiple_files"
              value="multipleFiles"
            />
          </div>
          <div class="singleColumnGrid">
            <btn-grp slot="end" class="btnGrpClass btn-center">
              <btn text="Cancel" type="secondary" class v-on:click="backToSalaryReportPage"></btn>
              <btn text="Download" type="primary" class v-on:click="downLoadFiles"></btn>
            </btn-grp>
          </div>
        </div>
      </div>
    </div>
    <bottom-action-container class="position-fixed">
      <btn-grp slot="end">
        <btn text="Cancel" type="secondary" class></btn>
        <btn text="View Report" type="primary" class @click="DownloadReport"></btn>
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
export default {
  name: "SalaryReports",
  data() {
    return {
      showModal: false,
      isCostCenterChecked:false,
      isSalaryBandsChecked:false,
      salaryBands: [],
      costCenterList: [],
      employerContri:'',
      unpaidCTC:'',
      employeeInfoList: [
        {
          label: "Employee Name",
          value: "",
          checked: false
        },
        {
          label: "Reporting Manager",
          value: "",
          checked: false
        },
        {
          label: "Address 1",
          value: "",
          checked: false
        },
        {
          label: "Employee Code",
          value: "",
          checked: false
        },
        {
          label: "Passport No.",
          value: "",
          checked: false
        },
        {
          label: "Address 2",
          value: "",
          checked: false
        },
        {
          label: "Gender",
          value: "",
          checked: false
        },
        {
          label: "Passport Expiry Date",
          value: "",
          checked: false
        },
        {
          label: "City",
          value: "",
          checked: false
        },
        {
          label: "Father's Name",
          value: "",
          checked: false
        },
        {
          label: "PF No.",
          value: "",
          checked: false
        },
        {
          label: "State",
          value: "",
          checked: false
        },
        {
          label: "Mother's Name",
          value: "",
          checked: false
        },
        {
          label: "PF Date",
          value: "",
          checked: false
        },
        {
          label: "Country",
          value: "",
          checked: false
        },
        {
          label: "Spouse's Name",
          value: "",
          checked: false
        },
        {
          label: "UAN No.",
          value: "",
          checked: false
        },
        {
          label: "Pin",
          value: "",
          checked: false
        },
        {
          label: "PF Relationship",
          value: "",
          checked: false
        },
        {
          label: "EPF No.",
          value: "",
          checked: false
        },
        {
          label: "Telephone No.",
          value: "",
          checked: false
        },
        {
          label: "DOB",
          value: "",
          checked: false
        },
        {
          label: "Aadhar No.",
          value: "",
          checked: false
        },
        {
          label: "Mobile No.",
          value: "",
          checked: false
        },
        {
          label: "Employee status",
          value: "employeeStatus",
          checked: false,
          employeeStatus:''
        },
        {
          label: "EPS No.",
          value: "",
          checked: false
        },
        {
          label: "Blood Group",
          value: "",
          checked: false
        },
        {
          label: "Email",
          value: "",
          checked: false
        },
        {
          label: "PAN No.",
          value: "",
          checked: false
        },
        {
          label: "Personal Email",
          value: "",
          checked: false
        },
        {
          label: "DOJ",
          value: "",
          checked: false
        },
        {
          label: "ESS Access",
          value: "",
          checked: false
        },
        {
          label: "Emergency No.",
          value: "",
          checked: false
        },
        {
          label: "Resignation date",
          value: "",
          checked: false
        },
        {
          label: "ESI No.",
          value: "",
          checked: false
        },
        {
          label: "Marital Status",
          value: "",
          checked: false
        },
        {
          label: "Last working Date",
          value: "",
          checked: false
        },
        {
          label: "Cost center",
          value: "",
          checked: false
        },
        {
          label: "Confirmation Period",
          value: "",
          checked: false
        },
        {
          label: "Employee category ",
          value: "",
          checked: false
        },
        {
          label: "Emergency contact no.",
          value: "",
          checked: false
        },
        {
          label: "CTC",
          value: "",
          checked: false
        },
        {
          label: "Employee sub category",
          value: "",
          checked: false
        },
        {
          label: "Admin bank",
          value: "",
          checked: false
        },
        {
          label: "FBP",
          value: "",
          checked: false
        },
        {
          label: "Skill type",
          value: "",
          checked: false
        },
        {
          label: "IFSC code",
          value: "",
          checked: false
        },
        {
          label: "Annual VP",
          value: "",
          checked: false
        },
        {
          label: "Pay group",
          value: "",
          checked: false
        },
        {
          label: "Payment mode",
          value: "",
          checked: false
        },
        {
          label: "OT Hours / Days",
          value: "",
          checked: false
        },
        {
          label: "Location",
          value: "",
          checked: false
        },
        {
          label: "Sec Reporting Mgr",
          value: "",
          checked: false
        },
        {
          label: "Leave Encashment Day",
          value: "",
          checked: false
        },
        {
          label: "Salary Grade",
          value: "",
          checked: false
        },
        {
          label: "Enable ESS",
          value: "",
          checked: false
        },
        {
          label: "Notice Period Recovery Days",
          value: "",
          checked: false
        },
        {
          label: "Salary Band",
          value: "",
          checked: false
        },
        {
          label: "Is Metro",
          value: "",
          checked: false
        },
        {
          label: "Bank Name",
          value: "",
          checked: false
        }
      ],
      employeeStatusList: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
        { label: "Hold Salary", value: "holdSalary" }
      ],
      isEmployerContriChaked:false,
    };
  },
  methods: {
    onSelectMonth(e) {
      //console.log(e, this.salaryData);
    },
    onSelectEmployeeStatus(e) {
      //console.log(e);
    },
    employerContribution(e){
      if(e){
        this.employerContri = 'grossColumn';
      }else{
        this.employerContri = '';
      }
    },
    unpaidCTCComponents(e){
      if(e){
        this.unpaidCTC = 'grossColumn';
      }else{
        this.unpaidCTC = '';
      }
    },
    employeeInfoChecked(e, item){
      if(e && item.value == "employeeStatus"){
        item.employeeStatus = 'active'
      }else if(!e && item.value == "employeeStatus"){
item.employeeStatus = ''
      }
    },
    DownloadReport() {
      this.showModal = true;
    },
    downLoadFiles() {
      this.showModal = false;
    },
    backToSalaryReportPage() {
      this.showModal = false;
    },
    goBackToSalaryRegisterPage(){
      this.$router.push({
        path:`/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/salary_register`
      })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(6, minmax(180px, 1fr));
}
.s-twoColumnGrid {
  display: grid;
  grid-template-columns: 25% 25%;
  grid-row-gap: 0px;
  grid-column-gap: 10%;
}
.btn-center {
  position: relative;
  top: 70px;
  margin: auto;
}
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.heading_new {
  width: 270px;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
</style>
